
SJ.Camera =
class {
  constructor(scaleMod) {
    this._offset = createVector(-200, 0);
    this._offset.x += SJ.SCREEN_WIDTH*0.5;
    this._offset.y += SJ.SCREEN_HEIGHT*0.5;
    this._scale = scaleMod;

    this._targetPosition = createVector(0, 0);

    this._topPath = new SJ.CameraPath(SJ.V.cameraTopPath);
    this._bottomPath = new SJ.CameraPath(SJ.V.cameraBottomPath);

    this.freeCamOffset = {
      x:0,
      y:0
    }

    //Freewalk camera loading data from cookies
    this.areArrowsEnabled = SJ.Tools.cookieValue('areArrowsEnabled');

    if(!SJ.Tools.cookieValue('freeCamOffsetX'))
      document.cookie = "freeCamOffsetX = 0";

    if(!SJ.Tools.cookieValue('freeCamOffsetY'))
      document.cookie = "freeCamOffsetY = 0";

    this.freeCamOffset.x = parseInt(SJ.Tools.cookieValue('freeCamOffsetX')) || 0;
    this.freeCamOffset.y = parseInt(SJ.Tools.cookieValue('freeCamOffsetY')) || 0;

    this.areArrowsEnabled = this.areArrowsEnabled === 'true' ? true : false;
    //----------------------------------
    console.log(`%c -----FREECAMERA VARIABLES-----`, 'color: orange');

    console.log('FreeCam offset X: ' + this.freeCamOffset.x);
    console.log('FreeCam offset Y: ' + this.freeCamOffset.y);
    console.log(`FreeCam enabled: ${this.areArrowsEnabled}`);

    console.log(``);

    
    this.restart();
  }

  restart() {
    this._currentPosition = createVector(SJ.jumper.body.position.x, SJ.jumper.body.position.y);

    if(SJ.V.minCameraPosition != undefined) {
      this._minPosition = SJ.V.minCameraPosition;
    }else {
      this._minPosition = null;
    }

    this._setPathIndex();
  }

  _setPathIndex() {
    this._topPath.setPathIndex(this._currentPosition.x);
    this._bottomPath.setPathIndex(this._currentPosition.x);
  }

  update() {
    const jumperPos = SJ.jumper.body.position;
    const minY = this._topPath.getExpectedY();
    const maxY = this._bottomPath.getExpectedY();
    const targetY = constrain(jumperPos.y, minY, maxY);

    const LERP_SPEED_Y = 0.08;
    let LERP_SPEED_X = 0.15;
    
    //Saving variables in cookies
    if(this.areArrowsEnabled){
      LERP_SPEED_X = 0.08;
      document.cookie = "freeCamOffsetX = " + this.freeCamOffset.x;
      document.cookie = "freeCamOffsetY = " + this.freeCamOffset.y;
      document.cookie = "areArrowsEnabled = true";
    }
    else document.cookie = "areArrowsEnabled = false";
    //--------

    this._targetPosition.x = jumperPos.x;
    this._targetPosition.y = targetY;

    this._currentPosition.x = lerp(this._currentPosition.x, this._targetPosition.x, LERP_SPEED_X);
    this._currentPosition.y = lerp(this._currentPosition.y, this._targetPosition.y, LERP_SPEED_Y);
    
    if(this._minPosition != null) {
      this._currentPosition.x = max(this._currentPosition.x, this._minPosition.x + SJ.SCREEN_MIDDLE_X);
      this._currentPosition.y = max(this._currentPosition.y, this._minPosition.y + SJ.SCREEN_MIDDLE_Y);
    }
    
    if(this.areArrowsEnabled){
      this._currentPosition.x += this.freeCamOffset.x;
      this._currentPosition.y += this.freeCamOffset.y;
    }
    

  }

  transform() {
    const pos = this.getPosition();
    scale(this._scale);
    translate(pos.x, pos.y);
  }

  getPosition() {
    const curPos = this._currentPosition;
    return {
      x: -curPos.x+this._offset.x/this._scale, 
      y: -curPos.y+this._offset.y/this._scale
    };
  }

  drawPath() {
    this._topPath.draw(color(200, 100, 0));
    this._bottomPath.draw(color(100, 200, 0));
  }

  screenToWorld(p) {
    const screenPoint = p.copy();
    screenPoint.sub(this._offset);
    screenPoint.div(this._scale);
    screenPoint.add(this._currentPosition);
    return screenPoint;
  }

  moveWithArrows(keyCode){

    if(this.areArrowsEnabled){
      switch(keyCode){
        case 37:
          this.freeCamOffset.x -= 15;
        break;
        case 39:
          this.freeCamOffset.x += 15;
        break;
        case 38:
          this.freeCamOffset.y -= 15;
        break;
        case 40:
          this.freeCamOffset.y += 15;
        break;
      }
    }

    if(keyCode == 220)
      this.areArrowsEnabled = !this.areArrowsEnabled;

    //Setting cookies to 0
    if(keyCode == 114 || keyCode == 82 && this.areArrowsEnabled){
      document.cookie = "freeCamOffsetX = 0";
      document.cookie = "freeCamOffsetY = 0";

      this.freeCamOffset.x = parseInt(SJ.Tools.cookieValue('freeCamOffsetX'));
      this.freeCamOffset.y = parseInt(SJ.Tools.cookieValue('freeCamOffsetY'));
    }

  }

}